document.addEventListener('DOMContentLoaded', () => {
    const form = document.getElementById('searchProductInput');
    const input = document.getElementById('productSearchInput');
    const searchBtn = document.getElementById('searchProductDetails');
    const loader = document.getElementById('searchProductLoader');
    const tableContainer = document.getElementById('searchProductTableContainer');
    const messageBox = document.querySelector('.search-text-message');
  
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
  
      const query = input.value.trim();
  
      if (!query) {
        messageBox.textContent = 'Please enter a correct product name.';
        messageBox.classList.remove('hidden');
        return;
      }
  
      messageBox.classList.add('hidden');
      loader.style.display = 'block';
      tableContainer.innerHTML = '';
  
      try {
        const response = await fetch(`https://milton.marmeto.com/api/inventory/search?productName=${encodeURIComponent(query)}`);
        if (!response.ok) {
          throw new Error(`Error: ${response.status}`);
        }
  
        const data = await response.json();
        const results = data.results;
  
        if (!Array.isArray(results) || results.length === 0) {
          tableContainer.innerHTML = '<p>No results found.</p>';
          return;
        }
  
        renderResultsTable(results);
  
      } catch (err) {
        console.error(err);
        messageBox.textContent = 'Something went wrong while fetching data.';
        messageBox.classList.remove('hidden');
      } finally {
        loader.style.display = 'none';
      }
    });
  
    function renderResultsTable(results) {
      // Collect all unique facility names across all results
      const allFacilities = new Set();
      results.forEach(result => {
        result.facilityWiseInventory.forEach(fac => {
          allFacilities.add(fac.facilityName);
        });
      });
  
      const facilityNames = Array.from(allFacilities);
  
      let html = `
        <table class="search-product-result-table">
          <thead>
            <tr>
              <th>Product Name</th>
              <th>Variant Name</th>
              <th>D2C SKU</th>
              <th>Ecom SKU</th>
              <th>Primary SKU</th>
              <th>Price</th>
              <th>Total Inventory</th>
              ${facilityNames.map(name => `<th>${name}</th>`).join('')}
            </tr>
          </thead>
          <tbody>
      `;
  
      results.forEach(result => {
        const {
          productName,
          variantName,
          d2cSku,
          ecomSku,
          primarySku,
          variantPrice,
          total,
          facilityWiseInventory
        } = result;
  
        // Build a map for fast lookup
        const facilityMap = {};
        facilityWiseInventory.forEach(fac => {
          facilityMap[fac.facilityName] = fac.inventory;
        });
  
        html += `
          <tr>
            <td>${productName}</td>
            <td>${variantName}</td>
            <td>${d2cSku}</td>
            <td>${ecomSku}</td>
            <td>${primarySku}</td>
            <td>${variantPrice}</td>
            <td>${total}</td>
            ${facilityNames.map(name => `<td>${facilityMap[name] || 0}</td>`).join('')}
          </tr>
        `;
      });
  
      html += `</tbody></table>`;
      tableContainer.innerHTML = html;
    }
  });
  